// filepath: /Users/night/Desktop/ssbm-fundamentals/client/src/components/ToastNotification.js
import React, { useEffect, useState } from 'react';

const ToastNotification = ({ message, duration = 8000, setServerMessage }) => {
  const [visible, setVisible] = useState(!!message); // Track visibility of the toast

  useEffect(() => {
    if (message) {
      setVisible(true); // Show the toast when a new message is passed
      const timer = setTimeout(() => {
        setVisible(false); // Hide the toast after the duration
        setServerMessage(''); // Clear the message after hiding
      }, duration);

      return () => clearTimeout(timer); // Cleanup the timer on unmount or when message changes
    }
  }, [message, duration, setServerMessage]);

  if (!visible || !message) return null; // Don't render if the toast is not visible or no message

  // Extract success and message from the object
  const { success, message: text } = message;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '20px',
        left: '50%',
        transform: 'translateX(-50%)',
        backgroundColor: success ? '#28a745' : '#dc3545', // Green for success, red for errors
        color: 'white',
        padding: '10px 20px',
        borderRadius: '5px',
        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
        zIndex: 1000,
      }}
    >
      {text}
    </div>
  );
};

export default ToastNotification;